import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
export var ignoreAttribute = 'data-editor-content-component';

/**
 * Wraps content components in a data attribute to ignore
 */
export var contentComponentClickWrapper = function contentComponentClickWrapper(reactComponents) {
  if (!fg('platform_editor_content_component_ignore_click')) {
    return reactComponents;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-editor-content-component": 'true'
  }, reactComponents);
};